import { render, staticRenderFns } from "./DXOption.vue?vue&type=template&id=6f666900&scoped=true&"
import script from "./DXOption.vue?vue&type=script&lang=js&"
export * from "./DXOption.vue?vue&type=script&lang=js&"
import style0 from "./DXOption.vue?vue&type=style&index=0&id=6f666900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f666900",
  null
  
)

component.options.__file = "DXOption.vue"
export default component.exports